import React from 'react';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';
import PropTypes from 'prop-types';
import { SvgIcon } from 'fe-comp-svg-icon';

const PROP_TYPES = {
  glyph: PropTypes.any.isRequired, // same PropType as SvgIcon
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: ${theme.spacingMd};
  margin: ${theme.spacingMd} 0;
`;
const InfoSlotIcon = styled.div`
  padding-right: 12px;
`;
const InfoSlotTitle = styled.h4`
  font-size: ${theme.fontSizeSm};
  margin-top: 0;
  margin-bottom: ${theme.spacingXs};
  font-weight: ${theme.fontWeightSemibold};
`;

const IconInfoSlot = ({ glyph, title, children }) => (
  <Container>
    <InfoSlotIcon>
      <SvgIcon glyph={glyph} size={20} fill={theme.colorBase} />
    </InfoSlotIcon>
    <div>
      {title && <InfoSlotTitle>{title}</InfoSlotTitle>}
      {children}
    </div>
  </Container>
);

IconInfoSlot.propTypes = PROP_TYPES;
IconInfoSlot.displayName = 'IconInfoSlot';

export { IconInfoSlot };
